import React from 'react'

import { AboutWrapper } from './styles'

function About() {
  return (
    <AboutWrapper>
      <img src="/assets/images/tela_login.png" width="100%" alt="Logo" />
    </AboutWrapper>
  )
}

export default About
